var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Tipo de documento:"),
              _c("span", [_vm._v(_vm._s(_vm.tipoDocumento))])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Protocolo:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.protocolo))])
            ])
          ]),
          _c(
            "el-col",
            { attrs: { sm: 12 } },
            [
              _c("p", { staticClass: "info" }, [_vm._v("Responsável(eis):")]),
              _vm._l(_vm.documento.assinadores, function(assinador) {
                return _c("div", { staticClass: "item-list" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        assinador.responsavel.usuario.pessoa.nomeRazaoSocial
                      )
                    )
                  ])
                ])
              }),
              _c("p")
            ],
            2
          ),
          _c(
            "el-col",
            { attrs: { sm: 12 } },
            [
              _c("p", { staticClass: "info" }, [
                _vm._v("Data(s) de assinatura:")
              ]),
              _vm._l(_vm.documento.assinadores, function(assinador) {
                return _c("div", { staticClass: "item-list" }, [
                  _c("span", [_vm._v(_vm._s(assinador.dataAssinatura))])
                ])
              }),
              _c("p")
            ],
            2
          ),
          _vm._t("baixar")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0aeac774", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aeac774","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/DocumentoAssinatura.vue
// module id = null
// module chunks = 